import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

export type CardElevation = 'flat' | 'raised' | 'floating';
export type CardPadding = 'none' | 'sm' | 'md' | 'lg';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  elevation?: CardElevation;
  padding?: CardPadding;
  /** Baslik satiri — verilirse ust kenarda ayrilmis bir bolge cizilir. */
  title?: ReactNode;
  /** Baslik satirinin sagindaki eylem (buton, menu…). */
  action?: ReactNode;
};

export function Card({
  elevation = 'raised',
  padding = 'md',
  title,
  action,
  className,
  children,
  ...rest
}: CardProps) {
  const classes = [styles.card, styles[elevation], className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {title ? (
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          {action ? <div className={styles.action}>{action}</div> : null}
        </div>
      ) : null}
      <div className={styles[`pad-${padding}`]}>{children}</div>
    </div>
  );
}
